document.addEventListener("DOMContentLoaded", function(){


const createBtn =
document.querySelector(
'.art-main-submit-btn'
);



if(!createBtn){
    return;
}





createBtn.addEventListener(
'click',
async function(){



    // 防重复生成

    if(
        window.AIProcessManager &&
        !window.AIProcessManager.start()
    ){

        return;

    }





    const userFile =
    window.currentUploadedFile;



    if(!userFile){

        alert(
        "Please upload your photo!"
        );


        if(window.AIProcessManager){

            window.AIProcessManager.finish();

        }

        return;

    }






    const wrapper =
    document.getElementById(
    'ai-progress-wrapper'
    );


    const spinner =
    document.getElementById(
    'spinner-box'
    );


    const txt =
    document.getElementById(
    'display-text'
    );



    const progressBar =
    document.getElementById(
    'ai-progress-bar'
    );


    const progressStatus =
    document.getElementById(
    'ai-progress-status'
    );


    const countdown =
    document.getElementById(
    'ai-countdown'
    );





    if(wrapper){

        wrapper.style.display="block";

    }



    if(txt){

        txt.innerText =
        "Creating your artwork...";

    }





    if(spinner){

        spinner.style.display="block";

        spinner.classList.add(
        "do-spin"
        );

    }




    createBtn.innerText =
    "Creating your artwork...";


    createBtn.disabled=true;






    let timeLeft=60;



    const interval=setInterval(()=>{


        timeLeft--;



        if(countdown){

            countdown.innerText =
            `~${timeLeft}s`;

        }




        if(progressBar){

            progressBar.style.width =
            Math.min(
            95,
            ((60-timeLeft)/60)*95
            )
            +"%";

        }





        if(progressStatus){


            if(timeLeft>40){


                progressStatus.innerText =
                "0/3 ready — Mixing colors and adding a gentle glow...";


            }
            else if(timeLeft>20){


                progressStatus.innerText =
                "1/3 ready — Adding magical details...";


            }
            else if(timeLeft>5){


                progressStatus.innerText =
                "2/3 ready — Final touches are being painted...";


            }
            else{


                progressStatus.innerText =
                "3/3 ready — Finalizing your artwork...";


            }

        }



    },1000);







    try{


        const hdUrls =
        await window.processArtGeneration(
            userFile,
            window.CURRENT_SKU
        );



        if(
        hdUrls &&
        hdUrls.length
        ){


            if(progressStatus){

                progressStatus.innerText =
                "3/3 ready — Your artwork is complete!";

            }



            if(progressBar){

                progressBar.style.width="100%";

            }



            saveToHistory(
            hdUrls[0]
            );


        }



    }
    catch(err){


        console.error(err);


        alert(
        err.message
        );


    }
    finally{


        clearInterval(interval);



        setTimeout(()=>{


            if(wrapper){

                wrapper.style.display="none";

            }



            createBtn.innerText =
            "② Create artwork";


            createBtn.disabled=false;




            if(window.AIProcessManager){

                window.AIProcessManager.finish();

            }



        },1500);



    }




});



});